import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { languageChange, currentSelectedLanguage, } from "../../../StateManagement/actions";
const ModalPopUp = forwardRef(function WarnUnSaveChangesPopUp(
  {
    isOpen,
    //  onCancel, onConfirm,
    headerText,
  },
  ref
) {
  const modalDialog = useRef();
  const onConfirmRef = useRef();
  const onCancelRef = useRef();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [message, setMessage] = useState("");
  const selectedLanguage = useSelector(currentSelectedLanguage);

  useImperativeHandle(ref, () => ({
    open(message, onConfirm, onCancel) {
      setMessage(message);
      setIsOpenModal(true);

      onConfirmRef.current = onConfirm;
      onCancelRef.current = onCancel;
    },
    close() {
      setIsOpenModal(false);
    },
  }));

  const onCancel = () => {
    if (onCancelRef.current) onCancelRef.current();
    setIsOpenModal(false);
  };
  const onConfirm = () => {
    if (onConfirmRef.current) onConfirmRef.current();
    setIsOpenModal(false);
  };
  //if (!isOpen) return null;
  return (
    <>
      {isOpenModal && (
        <div className="child-popup warning-popup" id="warningModal" ref={modalDialog}>
          <div className="Settingmodal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="mleft15 justify-content-center mb-3 modalheaederleft" style={{ marginLeft: "9px", marginRight: "0px", }}>
                <h4 className="mb-2 mt-2 text-danger fw-bold">
                  {selectedLanguage.LstLanguageCodes.UI_Update}
                </h4>
              </div>
              <hr className="modalhorizontal" />
              <div
                className="d-flex justify-content-center flex-column mb-3 text-center"
                style={{ marginTop: "20px" }}>
                <p
                  className="w-100 f-w550"
                  style={{ display: "content", fontSize: "18px" }}>
                  {message}
                </p>
              </div>
              <div className="d-flex justify-content-center mb-4">
                <button
                  type="button"
                  className="btn btn-danger px-4 me-1"
                  onClick={onCancel}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4 ms-3"
                  onClick={onConfirm}>
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export default ModalPopUp;
